import Vue from "vue";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        this.initRequestVerificationToken();

        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                this.$store.commit("infoRequestStore/setIsShow", false)

                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.resetCssAnimations();
        this.setHeader();
        this.setResponsive();
        this.setShareButton();
        this.setAnalytics();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setHeader() {
        let header = document.getElementById("Header");

        if (header) {
            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-minify", "");
                } else {
                    header.removeAttribute("data-minify");
                }
            });
        }
    }

    private static setResponsive() {
        let header = document.getElementById("Header"),
            buttonMenuOpen = document.getElementById("MenuOpen"),
            buttonAccountOpen = document.getElementById("AccountOpen"),
            buttonAccountClose = document.getElementById("AccountClose"),
            AccountMenu = document.getElementById("AccountMenu"),
            body = document.getElementById("body"),
            scrim = document.getElementById("ScrimTop"),
            menuClose = document.getElementById("MenuClose"),
            acList = document.getElementsByClassName("ac-list")

        document.querySelectorAll(".back-menu").forEach(element => {
            element.addEventListener("click", function () {
                document.querySelectorAll(".ac-list").forEach(list => {
                    list.classList.remove("show");
                });
            });
        });

        if (buttonMenuOpen) {
            buttonMenuOpen.addEventListener("click", function () {
                header.classList.add("show");
                body.classList.add("overflow");
            });

            menuClose.addEventListener("click", function () {
                header.classList.remove("show");
                body.classList.remove("overflow");
            });

            scrim.addEventListener("click", function () {
                header.classList.remove("show");
                body.classList.remove("overflow");
                AccountMenu.classList.remove("show");
                scrim.classList.remove("show");
            });
        }

        if (buttonAccountOpen) {
            buttonAccountOpen.addEventListener("click", function () {
                AccountMenu.classList.add("show");
                scrim.classList.add("show");
                body.classList.add("overflow");
            });

            buttonAccountClose.addEventListener("click", function () {
                AccountMenu.classList.remove("show");
                scrim.classList.remove("show");
                body.classList.remove("overflow");
            });
        }
    }

    private static setShareButton() {
        let openShare = document.getElementById("OpenShare"),
            shareBox = document.getElementById("ShareBox");

        if (openShare) {
            openShare.addEventListener("click", function () {
                shareBox.classList.toggle("show");
            });
        }
    }

    private static setAnalytics() {
        let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
        for (const item of dataGaeventLinkTrue) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendEvent(
                        this.getAttribute("data-ganame") ? this.getAttribute("data-ganame") : "click",
                        this.getAttribute("data-gacategory"),
                        this.getAttribute("data-galabel") === "link" ? this.getAttribute("href") : this.getAttribute("data-galabel"),
                    );
                });
            }
        }

        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }
    }
}